export class PrivacyPolicyPage {
  init(): void {
    // プライバシーポリシーページ
  }
}
